export default __webpack_public_path__ + "static/media/gdpr-compliant.327b92b2.svg";